/**
 * Calling a saved number. A `tel:` link hands the number to the phone's dialer (or a desktop
 * calling app), where the patient still presses call; inside the mobile WebView shell the shell
 * dials instead (`request.tel`, data-contract.md §3.2), since a WebView may not follow `tel:`.
 */

import type { MouseEvent } from "react";

import { isInWebView, postToShell } from "../bridge/webview";

export const telHref = (phone: string): string => `tel:${phone.replace(/[^\d+]/g, "")}`;

/** onClick for a `tel:` link: lets the browser follow it, or hands the number to the shell. */
export function onDial(phone: string) {
  return (e: MouseEvent<HTMLAnchorElement>) => {
    if (!isInWebView()) return;
    e.preventDefault();
    postToShell({ type: "request.tel", phone });
  };
}

/** "+919876543210" → "+91 98765 43210", for reading a number out before calling it. */
export function formatPhone(phone: string): string {
  const m = /^\+91(\d{5})(\d{5})$/.exec(phone);
  return m ? `+91 ${m[1]} ${m[2]}` : phone;
}
